module.exports = __webpack_public_path__ + "img/frame (9).91cda937.jpg";